document.addEventListener('DOMContentLoaded', () => {
    initAgreementFileControls();
    initCategoryAreaModalControls();
});

function initAgreementFileControls() {
    const agreementFileName = document.getElementById('agreement_file_name');
    const btnUploadAgreementFile = document.getElementById('btn_upload_agreement_file');
    const btnDownloadAgreementFile = document.getElementById('btn_download_agreement_file');
    const btnDeleteAgreementFile = document.getElementById('btn_delete_agreement_file');

    if (!agreementFileName || !btnUploadAgreementFile) {
        return;
    }

    btnUploadAgreementFile.addEventListener('change', (event) => {
        const file = event.target.files?.[0];
        if (!file) {
            return;
        }

        agreementFileName.textContent = file.name;
        agreementFileName.classList.add('has-file');

        if (btnDeleteAgreementFile) {
            btnDeleteAgreementFile.classList.remove('d-none');
        }
    });

    if (!btnDeleteAgreementFile) {
        return;
    }

    btnDeleteAgreementFile.addEventListener('click', () => {
        btnUploadAgreementFile.value = '';
        agreementFileName.textContent = btnDeleteAgreementFile.getAttribute('data-delete-confirm-note');
        agreementFileName.classList.remove('has-file');

        if (btnDownloadAgreementFile) {
            btnDownloadAgreementFile.classList.add('d-none');
        }

        btnDeleteAgreementFile.classList.add('d-none');
    });
}

function initCategoryAreaModalControls() {
    const selectedCategory = document.getElementById('selected_category');
    const notSelectedArea = document.getElementById('not_selected_area');
    const selectedArea = document.getElementById('selected_area');
    const corporationCategoryTable = document.getElementById('corporation_category_table');
    const btnCreateCorporationCategory = document.getElementById('btn_create_corporation_category');
    const btnPopupRegister = document.getElementById('btn_popup_register');

    if (
        !selectedCategory
        || !notSelectedArea
        || !selectedArea
        || !corporationCategoryTable
        || !btnCreateCorporationCategory
        || !btnPopupRegister
    ) {
        return;
    }

    const CHANGE_STATUS = Object.freeze({
        NO_CHANGE: 0,
        UPDATE: 1,
        CREATE: 2,
        DELETE: 3,
    });

    const subCategoryList = JSON.parse(selectedCategory.getAttribute('data-sub-category-list') || '[]');
    const NATIONAL_AREA_OPTION = Object.freeze({
        value: notSelectedArea.getAttribute('data-national-area-value') || '',
        text: notSelectedArea.getAttribute('data-national-area-text') || '',
    });
    const areaList = JSON.parse(notSelectedArea.getAttribute('data-area-list') || '[]');
    const categoryAreaRegisterList = JSON.parse(
        notSelectedArea.getAttribute('data-category-area-register-list') || '[]'
    );

    let usedAreaIds = [];

    corporationCategoryTable.addEventListener('click', (event) => {
        const btnEditCorporationCategory = event.target.closest('#btn_edit_corporation_category');
        if (!btnEditCorporationCategory) {
            return;
        }

        const categoryId = btnEditCorporationCategory.getAttribute('data-category-id');
        if (!categoryId) {
            return;
        }

        resetAllSelects(categoryId);

        selectedCategory.value = categoryId;
        selectedCategory.disabled = true;

        const corporationCategoryList = document.getElementById(`corporation_category_list[${categoryId}]`);
        if (!corporationCategoryList) {
            return;
        }

        const selectedAreaOptions = corporationCategoryList.querySelectorAll('option');
        const notSelectedAreaOptions = notSelectedArea.querySelectorAll('option');

        if (notSelectedAreaOptions.length - 1 === selectedAreaOptions.length) {
            const nationalOption = notSelectedArea.querySelector(`option[value="${NATIONAL_AREA_OPTION.value}"]`);
            if (nationalOption) {
                nationalOption.disabled = false;
                nationalOption.click();
            }
        } else {
            notSelectedAreaOptions.forEach((option) => {
                if (corporationCategoryList.querySelector(`option[value="${option.value}"]`)) {
                    option.click();
                }
            });
        }

        const btnPopupDelete = document.getElementById('btn_popup_delete');
        if (!btnPopupDelete) {
            return;
        }

        btnPopupDelete.addEventListener('click', () => {
            const selectedCategoryId = selectedCategory.value;
            const changeStatus = document.querySelector(
                `input[name="corporation_category_list[${selectedCategoryId}][change_status]"]`
            );
            if (!changeStatus) {
                return;
            }

            const changeStatusValue = Number(changeStatus.value);
            const tableBody = btnEditCorporationCategory.closest('tbody');
            const corporationCategoryListElement = document.getElementById(
                `corporation_category_list[${selectedCategoryId}]`
            );

            if (changeStatusValue === CHANGE_STATUS.NO_CHANGE || changeStatusValue === CHANGE_STATUS.UPDATE) {
                changeStatus.value = CHANGE_STATUS.DELETE;
                tableBody?.remove();
            } else if (changeStatusValue === CHANGE_STATUS.CREATE) {
                tableBody?.remove();
                corporationCategoryListElement?.remove();
            }
        }, { once: true });
    });

    btnCreateCorporationCategory.addEventListener('click', () => {
        resetAllSelects();

        const usedCategoryIdList = [];
        document.querySelectorAll('#btn_edit_corporation_category').forEach((item) => {
            usedCategoryIdList.push(item.getAttribute('data-category-id'));
        });

        selectedCategory.querySelectorAll('option').forEach((item) => {
            if (usedCategoryIdList.includes(item.value)) {
                item.remove();
            }
        });
    });

    btnPopupRegister.addEventListener('click', () => {
        const categoryId = selectedCategory.value;
        const selectedCategoryOption = selectedCategory.options[selectedCategory.selectedIndex];
        if (!categoryId || !selectedCategoryOption) {
            return;
        }

        const categoryName = selectedCategoryOption.text;
        const changeStatus = document.querySelector(
            `input[name="corporation_category_list[${categoryId}][change_status]"]`
        );
        const changeStatusValue = changeStatus ? Number(changeStatus.value) : null;

        if (changeStatus && changeStatusValue !== CHANGE_STATUS.DELETE) {
            if (changeStatusValue === CHANGE_STATUS.NO_CHANGE) {
                changeStatus.value = CHANGE_STATUS.UPDATE;
            }

            const targetAreaList = document.querySelector(
                `select[name="corporation_category_list[${categoryId}][target_area_list][area_id][]"]`
            );
            if (!targetAreaList) {
                return;
            }

            resetOption(targetAreaList);
            selectedArea.querySelectorAll('option').forEach((item) => {
                targetAreaList.appendChild(new Option(item.text, item.value, false, true));
            });

            return;
        }

        if (changeStatusValue === CHANGE_STATUS.DELETE) {
            document.getElementById(`corporation_category_list[${categoryId}]`)?.remove();
        }

        const template = document.getElementById('corporation_category_table_template');
        if (!template) {
            return;
        }

        const clone = template.content.cloneNode(true);

        clone.querySelector('td:nth-child(2)').textContent = categoryName;
        clone.querySelector('#btn_edit_corporation_category').setAttribute('data-category-id', categoryId);

        const corporationCategoryList = clone.querySelector('#corporation_category_list');
        corporationCategoryList.setAttribute('id', `corporation_category_list[${categoryId}]`);

        clone.querySelector('#hidden_category_id').value = categoryId;
        clone.querySelector('#hidden_category_id').setAttribute(
            'name',
            `corporation_category_list[${categoryId}][category_id]`
        );

        if (changeStatusValue === CHANGE_STATUS.DELETE) {
            clone.querySelector('#hidden_change_status').value = CHANGE_STATUS.UPDATE;
        } else {
            clone.querySelector('#hidden_change_status').value = CHANGE_STATUS.CREATE;
        }

        clone.querySelector('#hidden_change_status').setAttribute(
            'name',
            `corporation_category_list[${categoryId}][change_status]`
        );

        const hiddenTargetAreaList = clone.querySelector('#hidden_target_area_list');
        selectedArea.querySelectorAll('option').forEach((item) => {
            hiddenTargetAreaList.appendChild(new Option(item.text, item.value, false, true));
        });
        hiddenTargetAreaList.setAttribute('name', `corporation_category_list[${categoryId}][target_area_list][area_id][]`);

        corporationCategoryTable.appendChild(clone);
    });

    selectedCategory.addEventListener('change', (event) => {
        const categoryId = event.target.value;
        resetAllSelects(categoryId);
        selectedCategory.value = categoryId;
    });

    [notSelectedArea, selectedArea].forEach((select) => {
        select.addEventListener('click', (event) => {
            const targetOption = event.target;
            if (targetOption.tagName !== 'OPTION' || targetOption.disabled) {
                return;
            }

            const isLeft = select === notSelectedArea;
            const value = targetOption.value;

            if (value === NATIONAL_AREA_OPTION.value) {
                if (isLeft) {
                    moveAllOptions(notSelectedArea, selectedArea);
                    createNationalOption(notSelectedArea, true);
                } else {
                    notSelectedArea.querySelector(`option[value="${NATIONAL_AREA_OPTION.value}"]`)?.remove();
                    moveAllOptions(selectedArea, notSelectedArea);
                }
            } else {
                const destination = isLeft ? selectedArea : notSelectedArea;
                destination.appendChild(targetOption);
            }

            sortSelect(notSelectedArea);
            sortSelect(selectedArea);
        });
    });

    function moveAllOptions(from, to) {
        const options = Array.from(from.options);
        options.forEach((option) => to.appendChild(option));
    }

    function sortSelect(selectElement) {
        const options = Array.from(selectElement.options);

        options.sort((optionA, optionB) => {
            const valueA = Number(optionA.value);
            const valueB = Number(optionB.value);

            return valueA - valueB;
        });

        selectElement.innerHTML = '';
        options.forEach((option) => selectElement.appendChild(option));
    }

    function resetOption(element) {
        element.innerHTML = '';
    }

    function createNationalOption(element, disabled = false) {
        const nationalOption = document.createElement('option');
        nationalOption.value = NATIONAL_AREA_OPTION.value;
        nationalOption.text = NATIONAL_AREA_OPTION.text;
        nationalOption.disabled = disabled;
        element.appendChild(nationalOption);
    }

    function resetAllSelects(categoryId = null) {
        resetOption(selectedCategory);
        resetOption(notSelectedArea);
        resetOption(selectedArea);

        usedAreaIds = [];

        subCategoryList.forEach((item) => {
            const option = document.createElement('option');
            option.value = item.sub_category_id;
            option.text = item.sub_category_name;
            selectedCategory.appendChild(option);
        });
        selectedCategory.disabled = false;

        createNationalOption(notSelectedArea);

        areaList.forEach((item) => {
            const option = document.createElement('option');
            option.value = item.area_id;
            option.text = item.area_name;
            notSelectedArea.appendChild(option);
        });

        if (!categoryId) {
            return;
        }

        categoryAreaRegisterList.forEach((item) => {
            if (item.category_id === Number(categoryId)) {
                usedAreaIds = item.used_area_list;
            }
        });

        notSelectedArea.querySelectorAll('option').forEach((option) => {
            if (usedAreaIds.length > 0) {
                const nationalOption = notSelectedArea.querySelector(`option[value="${NATIONAL_AREA_OPTION.value}"]`);
                if (nationalOption) {
                    nationalOption.disabled = true;
                }
            }

            if (usedAreaIds.map((item) => item.area_id).includes(Number(option.value))) {
                option.disabled = true;
            }
        });
    }
}